import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal";

const ConfigProfileInternetHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Internet profile settings"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            Internet Profiles. Define a condition to apply to traffic on the
            internet side (end customer IP addresses).
          </p>
          <ul>
            <li>
              <b>PROFILE NAME</b>: Profile name.
            </li>
            <li>
              <b>ADDRESS</b>: IP Address or range of end customers.
            </li>
            <li>
              <b>PROTOCOL</b>: Transport protocol. Possible values: TCP, UDP or
              any protocol (0-255). Allows 'any' or '*'.
            </li>
            <li>
              <b>PORT</b>: Port (only for TCP and UDP protocols). Numeric (1-2^16). Allows 'any' or '*'.
            </li>
          </ul>
          <p>
            Click on the refresh{" "}
            <i className="material-icons valign-icon">refresh</i> icon to
            refresh profiles information. Pending changes, if any, will be lost
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Entry...</b>, <b>Merge Entries From File...</b>
            and <b>Replace Entry From File...</b> These actions are identical to be buttons
            above the list.
          </p>
          <h5> Above the entries list: </h5>
            <p>
              Click on the <b>Add Entry...</b>, button to create a new entry
            </p>
            <p>
              Click on the <b>Merge Entries from File...</b>, button to open a file selection
              modal, each line will be added to the entry list except those already present
            </p>
            <p>
              Click on the <b>Replace Entries from File...</b>, button to open a file selection
              modal, will replace all the entry list items.
            </p>
            <p>Each line of the file should follow this convention:
              <div className="text-code">
                address/range[ protocol(allows 'any' or *)[ port(allows 'any' or *)]]
              </div>
            </p>
          <h5> Inside the entries list: </h5>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i> to
            remove the entry.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to open a modal to edit the entry.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default ConfigProfileInternetHelpModal;
